import * as React from 'react'
import { FC, useState, useRef, useEffect, useCallback } from 'react'
import { Audio } from '../../../Icons/'

import './AudioPlayer.scss'

interface Props {
    file: string
}

const AudioPlayer: FC<Props> = ({ file }) => {
    const [playing, setPlaying] = useState(false)
    const audioPlayer = useRef<HTMLAudioElement>(null)

    const onPlayerHandle = useCallback(() => {
        if (playing) {
            audioPlayer.current?.pause()
            setPlaying(false)
        } else {
            audioPlayer.current?.play()
            setPlaying(true)
        }
    }, [audioPlayer, playing])

    return (
        <article className="AudioPlayer">
            <div className={`AudioPlayer__icon ${playing ? 'playing' : ''}`} onClick={onPlayerHandle} title="Click to play">
                <Audio />
            </div>
            <audio ref={audioPlayer} controls loop={true} src={file}></audio>
        </article>
    )
}

export default AudioPlayer
